import React from "react";

function ExpertConsultationSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="43"
      // height="43"
      className="w-7 h-7 lg:w-[48px] lg:h-[43px]"
      fill="none"
      viewBox="0 0 48 43"
    >
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M32.834 34.75l4.416 4.417 8.834-8.834M24 28.125h-8.833c-4.116 0-6.174 0-7.797.672a8.833 8.833 0 00-4.78 4.781c-.673 1.623-.673 3.681-.673 7.797M31.73 2.267a8.836 8.836 0 010 16.383m-4.417-8.192a8.833 8.833 0 11-17.667 0 8.833 8.833 0 0117.667 0z"
      ></path>
    </svg>
  );
}

export default ExpertConsultationSvg;
